import { apiClient } from "..";

export interface NotificationType {
    id: string;
    type: string;
    read_at: string | null;
    data: {
        type: string;
        message: string;
        url?: string;
        [key: string]: any;
    };
    created_at: string;
    updated_at: string;
}

export const getNewNotification = async () => {
    return await apiClient.get(`/notifications`);
};

export const markNotificationAsRead = async (notificationId: string) => {
    return await apiClient.patch(`/notifications/${notificationId}`, {
        read: true
    });
};

export const clearAllNotifications = async () => {
    return await apiClient.post(`/notifications/clear-all`);
};
